// types
import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
  refresh: false,
  isRefreshing: false
};

// ==============================|| SLICE - MENU ||============================== //

const ui = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setRefresh(state, action) {
      state.refresh = action.payload;
    },
    setIsRefreshing(state, action) {
      state.isRefreshing = action.payload;
    }
  }
});

export default ui.reducer;

export const { setRefresh, setIsRefreshing } = ui.actions;
